<template>
    <div v-for="product in filteredProducts ?? []" :key="product.SKU+tick">
        <ProductListElement v-if="mode === 'list' || mode === 'quick'"
                            :line_type="line_type"
                            :mode="mode"
                            :qty="qty"
                            :product="product"
                            :custlist="custlist"
                            :updating="$store.state.parties.updatingSKUCartQuantities[product.SKU]"/>


        <ProductReplacementListElement v-if="mode=== 'replacement'"
                                       :mode="mode"
                                       :product="product"
                                       :already-added="alreadyAdded"
                                       @add-replacement-product="addReplacementProduct"
        />

        <ProductOrderListElement v-if="mode === 'party'" :mode="party"
                                 :product="product" :custlist="custlist"
                                 :line_type="line_type"
                                 :updating="$store.state.parties.updatingSKUCartQuantities[product.SKU]"
                                 @add-to-cart-clicked="addToCartClicked"
                                 @remove-from-cart-clicked="removeFromCartClicked"
                                 @make-reservation-clicked="makeReservationClicked"
                                 @release-reservation-clicked="releaseReservationClicked"
                                 @make-backorder-clicked="makeBackorderClicked"
                                 @cancel-backorder-clicked="cancelBackorderClicked"
                                 @make-return-clicked="makeReturnClicked"
                                 @cancel-return-clicked="cancelReturnClicked"
        />
       <ProductPartySummaryElement v-if="mode === 'party-summary'" mode="party-summary"
                               :product="product" :custlist="custlist"
                               :line_type="line_type"
                               :expanded="lineIsExpanded(product.SKU)"
                               :updating="$store.state.parties.updatingSKUCartQuantities[product.SKU]"
                               @add-to-cart-clicked="addToCartClicked"
                               @remove-from-cart-clicked="removeFromCartClicked"
                               @make-reservation-clicked="makeReservationClicked"
                               @release-reservation-clicked="releaseReservationClicked"
                               @make-backorder-clicked="makeBackorderClicked"
                               @cancel-backorder-clicked="cancelBackorderClicked"
                               @make-return-clicked="makeReturnClicked"
                               @cancel-return-clicked="cancelReturnClicked"
                               @expand-line="expandLine"
      />
        <ProductOrderListElement v-if="mode === 'summary'" mode="summary"
                                 :product="product" :custlist="custlist"
                                 :line_type="line_type"
                                 :updating="$store.state.parties.updatingSKUCartQuantities[product.SKU]"
        />

        <ProductFocusListElement v-if="mode === 'focuslist'"
                                 mode="focuslist"
                                 :product="product"
                                 :party="party"
                                 @add-focus-product="addFocusProduct"
                                 @remove-focus-product="removeFocusProduct"
        />

        <ProductBudgetListElement v-if="mode === 'budgetlimit'"
                                  mode="budgetlimit"
                                  :product="product"
                                  :budget-active="budgetActive"
                                  :remaining-budget="remainingBudget"
                                  :budget-items-selected="budgetItemsSelected"
                                  :budget-price-list="budgetPriceList"
                                  @budget-item-picked="budgetItemPicked"
                                  @budget-item-removed="budgetItemRemoved"
        />
    </div>

</template>

<script>
 import { ref } from 'vue'
 import { useStore } from 'vuex'
 import ProductListElement from "./elements/ProductListElement";
 import ProductOrderListElement from "./elements/ProductOrderListElement";
 import ProductBudgetListElement from "./elements/ProductBudgetListElement";
 import ProductFocusListElement from "./elements/ProductFocusListElement";
 import ProductReplacementListElement from "./elements/ProductReplacementListElement";
 import * as constants from '@/store/constants'
 import ProductPartySummaryElement from "@/components/lists/elements/ProductPartySummaryElement.vue";
 export default {
     name: "ProductList",
     components: {
       ProductPartySummaryElement,
       ProductBudgetListElement,ProductFocusListElement,ProductReplacementListElement, ProductListElement, ProductOrderListElement },
     props: {
         products: { type: Array, required: false },
         mode: { type: String, default: 'list' },
         line_type: {type: Number, default:1},
         qty: {type: Number, default:0},
         remainingBudget: {type: Number, default:0},
         budgetActive: {type:Boolean, default:true},
         budgetItemsSelected: {type: Array, default:()=>{return []}},
         budgetPriceList:{type: Array, default:()=>{return []}},
         custlist: null,
         party:null,
         expandedLines: {type:Array, default:()=>{return []}},
         filtered:{type:Boolean, default:false},
         alreadyAdded:{type:Boolean, default:false},
         tick:{type: Number, default:0}
     },
     emits:[
         'remove-from-cart-clicked','add-to-cart-clicked',
         'make-reservation-clicked','release-reservation-clicked',
         'make-backorder-clicked','cancel-backorder-clicked',
         'make-return-clicked','cancel-return-clicked',
         'add-focus-product','remove-focus-product',
         'add-replacement-product','budget-item-picked','budget-item-removed','expand-line'
     ],
     methods:{
         lineIsExpanded(sku){
             return this.expandedLines.includes(sku)
         },
         addToCartClicked(custId, sku){
             this.$emit('add-to-cart-clicked',custId,sku,this.line_type )
         },
         removeFromCartClicked(custId, sku){
             this.$emit('remove-from-cart-clicked',custId,sku,this.line_type )
         },
         makeReservationClicked(custId, lineId) {
             this.$emit('make-reservation-clicked', custId,lineId )
         },
         releaseReservationClicked(custId, lineId) {
             this.$emit('release-reservation-clicked', custId,lineId )
         },
         makeBackorderClicked(custId, lineId) {
             this.$emit('make-backorder-clicked', custId,lineId )
         },
         cancelBackorderClicked(custId, lineId) {
             this.$emit('cancel-backorder-clicked', custId,lineId )
         },
         expandLine(sku, custId) {
            this.$emit('expand-line', sku, custId)
         },
         makeReturnClicked(custId, lineId) {
             this.$emit('make-return-clicked', custId,lineId )
         },
         cancelReturnClicked(custId, lineId) {
             this.$emit('cancel-return-clicked', custId,lineId )
         },
         addFocusProduct(sku, price){
             this.$emit('add-focus-product', sku,price)
         },
         removeFocusProduct(sku){
             this.$emit('remove-focus-product', sku)
         },
          budgetItemPicked(product){
           this.$emit('budget-item-picked', product)
         },
         budgetItemRemoved(product){
            this.$emit('budget-item-removed', product)
         },
         addReplacementProduct(sku){
             this.$emit('add-replacement-product', sku)
         },

     },
     setup(props){
         const filteredProducts = ref(0)
         const store = useStore()
         //console.log("ProductList setup function")
         if(props.line_type !== constants.LINE_ELEVATED_HOST_GIFT && props.line_type !== constants.LINE_PROFILING){
             store.dispatch('loadAllCategories').then(()=>{
                 store.dispatch('loadAllProducts').then(()=>{
                     //                     console.log("Filterhit = ", props.products);

                     filteredProducts.value = store.getters.getProductCollection(props.products)

                 })
             })
         } else {
             store.dispatch('loadProductsOfType',{type:props.line_type}).then(res=>{
                 if(!props.products){

                     if(!props.filtered){
                         filteredProducts.value = res
                     }else{
                         filteredProducts.value = []
                     }

                  console.log('without')
                 }else{
                     filteredProducts.value = res.filter((item)=>{
                         return props.products.includes(item.SKU)
                     })
                   console.log('with')

                 }
             })

         }

         return {filteredProducts}
     }
 }
</script>

<style scoped>

</style>
